<template>
    <div>
        <c-switch color="success" pill v-model="content" />

        <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import { Switch as cSwitch } from '@/components/ui/vue'

export default {
    name: "IdentityFieldCheckbox_Bool",
    components: {
        cSwitch
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Boolean
        },

        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    computed: {
        content: {
            get() {
                if (this.value === null) {
                    return false
                }

                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },

        constraints() {
            let constr = this.field.constraints

            return constr
        }
    },
    methods: {
        check(val) {
            val = val || []
            
            this.errors = []

            if (this.constraints.required) {
                if (val.length < 1) {
                    this.errors.push(this.translator("identityField.requiredField"))
                }
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        }
    },
    mounted() {
        this.check(this.content)
    }
}
</script>